document.addEventListener('DOMContentLoaded', () => {
  const marquees = document.querySelectorAll('.announcement-marquee');
  const marqueeStates = new WeakMap();

  function setupMarquee(marquee) {
    const track = marquee.querySelector('.announcement-marquee__track');
    if (!track) return;

    const original = track.children[0];
    if (!original) return;

    const previousState = marqueeStates.get(marquee);
    if (previousState?.rafId) {
      cancelAnimationFrame(previousState.rafId);
    }

    // Rensa upp och bygg om spåret deterministiskt för en sömlös loop.
    track.innerHTML = '';
    track.style.transform = 'translateX(0)';

    const measureItem = original.cloneNode(true);
    track.appendChild(measureItem);
    const itemWidth = measureItem.getBoundingClientRect().width;
    track.innerHTML = '';

    if (!itemWidth) return;

    const viewportWidth = marquee.getBoundingClientRect().width || window.innerWidth;
    const repeatsPerSequence = Math.max(2, Math.ceil((viewportWidth * 2) / itemWidth));

    const sequenceA = document.createElement('div');
    sequenceA.className = 'announcement-marquee__sequence';

    for (let i = 0; i < repeatsPerSequence; i += 1) {
      sequenceA.appendChild(original.cloneNode(true));
    }

    const sequenceB = sequenceA.cloneNode(true);
    track.appendChild(sequenceA);
    track.appendChild(sequenceB);

    const loopWidth = sequenceA.getBoundingClientRect().width;
    if (!loopWidth) return;

    let x = -loopWidth;
    const speed = 0.35; // px per frame (justera här)
    let rafId = null;

    function animate() {
      x += speed;
      if (x >= 0) {
        x = -loopWidth;
      }
      track.style.transform = `translateX(${x}px)`;
      rafId = requestAnimationFrame(animate);
      marqueeStates.set(marquee, { rafId });
    }

    animate();
  }

  let resizeTimer = null;

  marquees.forEach((marquee) => {
    // Vänta på fonts innan vi mäter textbredd.
    document.fonts.ready.then(() => setupMarquee(marquee));
  });

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      marquees.forEach((marquee) => setupMarquee(marquee));
    }, 150);
  });
});
